import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import BankAccPresenter from "./BankAccPresenter";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import AssignBankDetail from "../BankAccounts/AssignBankDetails/AssignBankDetail";
import Progress from "../../../components/Progress";

class BankAccPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      openModal: false,
      bankData: "",
      count: 0,
      filteredPos: "",
      position: [],
    };
    this.presenter = new BankAccPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const position = await findObjectUseCase().execute("employees");
    console.log("POSITION", position);
    this.setState({ position });
  }

  getCollectionName() {
    return "employees";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    // this.setState({ objects });
    return objects;
  }

  async handleSelectedTitle(selectedPosition) {
    const selected = this.state.positionTitle.find(
      (data) => data.position === selectedPosition
    );
    if (selected) {
      this.setState({
        selectedPosition,
      });
    }
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "filteredPos") {
      this.onChangeFilter("Pointer", value, "position");
    } else if (field === "") {
    }
  }

  handleBankAssign(data) {
    this.setState({ openModal: true, bankData: data });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  // handleAction(action, data) {
  //   this.setState({ [action]: true, [action + "Data"]: data });
  // }

  // closeAction(action) {
  //   this.setState({ [action]: false });
  // }

  render() {
    const { objects, position, loading, count, limit, current } = this.state;
    const schema = this.getSchema(this.getCollectionName());

    if (!schema) return <Progress />;

    const predefinedPos = [
      ...new Set(position.map((item) => item?.position?.id)),
    ];
    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "bank" &&
        fields !== "branch" &&
        fields !== "accountNumber" &&
        fields !== "accountName"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Bank Account
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  {/* <div className="col-md-6"> */}
                  {/* <SearchSelect
                      required
                      value={this.state.filteredPos || ""}
                      onChange={(value) =>
                        this.onChangeOption("filteredPos", value)
                      }
                      onClickClear={() =>
                        this.onChangeOption("filteredPos", "")
                      }
                      options={[
                        { value: "" },
                        ...predefinedPos.map((position) => ({
                          label: position,
                          value: position,
                        })),
                      ]}
                    /> */}
                  {/* </div> */}
                  <div className="col-md-6">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">Bank Account</h4>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                assign={this.handleBankAssign.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Assign Bank List",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.openModal && (
          <AssignBankDetail
            closeModal={this.closeModal.bind(this)}
            // object={this.state.object}
            bankData={this.state.bankData}
            refetchData={this.refetchData.bind(this)}
          />
        )}
      </>
    );
  }
}

export default withRouter(BankAccPage);
